import { createApiAction } from 'src/api';

export const ADD_DOCUMENT_START = 'account/add_document_start';
export const ADD_DOCUMENT_SUCCESS = 'account/add_document_success';
export const ADD_DOCUMENT_FAILURE = 'account/add_document_failure';

export const DELETE_DOCUMENT_START = 'account/delete_document_start';
export const DELETE_DOCUMENT_SUCCESS = 'account/delete_document_success';
export const DELETE_DOCUMENT_FAILURE = 'account/delete_document_failure';

export const ADD_DOCUMENT_TYPE_START = 'account/add_document_type_start';
export const ADD_DOCUMENT_TYPE_SUCCESS = 'account/add_document_type_success';
export const ADD_DOCUMENT_TYPE_FAILURE = 'account/add_document_type_failure';

export const EDIT_DOCUMENT_TYPE_START = 'account/edit_document_type_start';
export const EDIT_DOCUMENT_TYPE_SUCCESS = 'account/edit_document_type_success';
export const EDIT_DOCUMENT_TYPE_FAILURE = 'account/edit_document_type_failure';

export const DELETE_DOCUMENT_TYPE_START = 'account/delete_document_type_start';
export const DELETE_DOCUMENT_TYPE_SUCCESS =
  'account/delete_document_type_success';
export const DELETE_DOCUMENT_TYPE_FAILURE =
  'account/delete_document_type_failure';

export const addAccountDocument = ({
  accountId,
  type,
  file,
  title,
  expirationDate,
  uploadDate,
}) => {
  const formData = new FormData();
  formData.append('document_type', type);
  formData.append('document_file', file);
  formData.append('document_title', title);
  formData.append('document_expiration_date', expirationDate);
  formData.append('document_uploaded_date', uploadDate);

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/documents/`,
      method: 'POST',
      formData,
    },
    [ADD_DOCUMENT_START, ADD_DOCUMENT_SUCCESS, ADD_DOCUMENT_FAILURE]
  );
};

export const deleteAccountDocument = ({ accountId, documentId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/documents/${documentId}/`,
      method: 'DELETE',
    },
    [DELETE_DOCUMENT_START, DELETE_DOCUMENT_SUCCESS, DELETE_DOCUMENT_FAILURE]
  );
};

export const addAccountDocumentType = ({
  accountId,
  name,
  description,
  frequency,
  uploadDays,
  startDate,
  needsApproval,
  // expirationDate,
}) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/document_types/`,
      method: 'POST',
      body: {
        document_type_type: name,
        document_type_description: description,
        document_type_upload_frequency_days: uploadDays || 0,
        document_type_upload_frequency_type: frequency,
        document_type_next_upload_date: startDate,
        document_type_needs_approval: needsApproval,
      },
    },
    [
      ADD_DOCUMENT_TYPE_START,
      ADD_DOCUMENT_TYPE_SUCCESS,
      ADD_DOCUMENT_TYPE_FAILURE,
    ]
  );
};
export const editAccountDocumentType = ({
  accountId,
  name,
  description,
  frequency,
  uploadDays,
  typeId,
  startDate,
  needsApproval,
  // expirationDate,
}) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/document_types/${typeId}/`,
      method: 'PUT',
      body: {
        document_type_type: name,
        document_type_description: description,
        document_type_upload_frequency_days: uploadDays || 0,
        document_type_upload_frequency_type: frequency,
        document_type_next_upload_date: startDate,
        document_type_needs_approval: needsApproval,
      },
    },
    [
      EDIT_DOCUMENT_TYPE_START,
      EDIT_DOCUMENT_TYPE_SUCCESS,
      EDIT_DOCUMENT_TYPE_FAILURE,
    ]
  );
};
export const deleteAccountDocumentType = ({ accountId, documentTypeId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/document_types/${documentTypeId}/`,
      method: 'DELETE',
    },
    [
      DELETE_DOCUMENT_TYPE_START,
      DELETE_DOCUMENT_TYPE_SUCCESS,
      DELETE_DOCUMENT_TYPE_FAILURE,
    ]
  );
};
